import { render, staticRenderFns } from "./XomeActions.vue?vue&type=template&id=1edf7350&"
import script from "./XomeActions.vue?vue&type=script&lang=js&"
export * from "./XomeActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports